import { FC, useContext, useEffect } from 'react';
import SplitIOTreatment from '../../../components/splitio/splitioTreatment';
import splitsDictionary from '../../../services/utils/splitsDictionary';
import AuthContext from '../../../context/AuthContext';
import { getToken } from '../../utils/getToken';
import { getRealm } from '../../utils/getRealm';

const realm = getRealm(window.location.host);

const KeycloakAuthCheck: FC = () => {
  const keycloak = useContext(AuthContext);

  useEffect(() => {
    getToken(keycloak)
      .then(() => {
        return;
      })
      .catch((error) => {
        console.error(error);
        keycloak.login();
      });
  });

  return <></>;
};

const KeycloakTimeoutHandler: FC = () => {
  return (
    <SplitIOTreatment
      featureName={splitsDictionary.KEYCLOAK_AUTH.name}
      treatmentValue="on"
      trafficType={splitsDictionary.KEYCLOAK_AUTH.traffic_type}
    >
      {(treatment: string) => {
        if (treatment === 'on' && realm !== false) {
          return <KeycloakAuthCheck />;
        } else {
          return <></>;
        }
      }}
    </SplitIOTreatment>
  );
};

export default KeycloakTimeoutHandler;
